import { Controller } from 'stimulus'
import truncate from 'html-truncate'
import serialize from 'form-serialize'

const localStorageKey = 'contactDetailsSubmitted'

export default class extends Controller {
  static targets = ['raw', 'preview', 'content', 'form', 'error']

  showError(message) {
    this.errorTarget.innerHTML = `<p>${message}</p>`
  }

  fieldsAsArray(fields) {
    return Object.keys(fields).reduce((fieldsArray, key) => {
      fieldsArray.push({ name: key, value: fields[key] })
      return fieldsArray
    }, [])
  }

  submit = async e => {
    const data = {
      fields: this.fieldsAsArray(serialize(this.formTarget, { hash: true })),
    }
    const response = await fetch(this.formTarget.getAttribute('action'), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    const responseData = await response.json()

    if (response.status !== 204) throw new Error(responseData.message)

    return responseData
  }

  validEmail(email) {
    // Very basic email address matching, we don't want to be overly pedantic here.
    const emailRegex = /(.+)@(.+){2,}\.(.+){2,}/
    return emailRegex.test(email)
  }

  valid() {
    const values = serialize(this.formTarget, { hash: true })
    if (!values.hasOwnProperty('firstname') || !values.hasOwnProperty('lastname') || !values.hasOwnProperty('email')) {
      this.showError('All fields are required.')
      return false
    } else if (!this.validEmail(values.email)) {
      this.showError('Please enter a valid email.')
      return false
    }
    return true
  }

  handleSubmit = async e => {
    e.preventDefault()
    if (!this.valid()) return
    this.submit()
      .catch(err => {
        // Don't penalize users for issues with the Hubspot API. Let's let them through regardless of success status. Log for reference
        console.log('Failed to submit', err)
      })
      .finally(_response => {
        localStorage.setItem(localStorageKey, new Date())
        this.reveal()
      })
  }

  reveal() {
    this.contentTarget.innerHTML = this._content
    this.element.classList.add('gated-content--open')
  }

  connect() {
    this._content = this.rawTarget.innerHTML

    try {
      if (localStorage.getItem(localStorageKey)) {
        this.reveal()
      }
    } catch (e) {
      console.log('Failed to check localStorage for previous form submission' + e.message)
    }

    this._preview = truncate(this._content, 200)
    this.previewTarget.innerHTML = truncate(this._content, 300)
    this.formTarget.addEventListener('submit', this.handleSubmit.bind(this))
  }
}
